import {
  Autocomplete,
  Box,
  Button,
  Card,
  Checkbox,
  Chip,
  Divider,
  FormControlLabel,
  Grid,
  MenuItem,
  Stack,
  TextField,
  Typography,
  CircularProgress,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { createShipmentRequestApi } from "../../../components/api/ShipmentRequestApiService";
import toast from "react-hot-toast";
import {
  retrieveAllOrdersApi,
  retrieveFilteredOrdersApi,
} from "../../../components/api/OrderApiService";
import ShipmentRequestView from "./ShipmentRequestView";
import order from "../../../menu-items/order";
import { retrieveQuantityByItemIdApi } from "../../../components/api/QuantityApiService";
import { format, parseISO } from "date-fns";
import { retrieveFastStakeholdersApi } from "../../../components/api/StakeholderApiService";
import { retrieveFastFilteredShippingInstructionsApi, retrieveFilteredShippingInstructionsApi } from "../../../components/api/ShippingInstructionApiService";
import WarehouseInventoryButton from "./Dialogs/WarehouseInventoryButton";
import { retrieveFilteredWarehouseRecordsApi } from "../../../components/api/WarehouseApiService";
import SearchIcon from "@mui/icons-material/Search";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import FilterSelect from "../../../components/FilterSelect";
import { add } from "lodash";
import NicotineSugarSummary from "./Dialogs/NicotineSugarSummary";

const AddShipmentRequest = (props) => {
  const { setAddViewStates, addViewStates, rows, setRows, setAddView, mapShipmentRequest } = props;
  useEffect(() => {
    setAddViewStates({
      ...addViewStates,
      orderType: "",
      shipmentQuantityUnit: "KG",
      approvalStatus: "Not Approved",
      shipmentEstimatedTimeOfDeparture: "",
    });
    console.log(addViewStates);
  }, []);

  const navigate = useNavigate();

  const determineDestination = (incoterm, portOfLoading, portOfDischarge) => {
    const incotermsUsingPortOfLoading = ["EXW", "FCA", "FAS", "FOB"];
    const incotermsUsingPortOfDischarge = ["CFR", "C&F", "CIF", "CPT", "CIP", "DAP", "DPU", "DDP"];

    const safeIncoterm = incoterm || "";
  
    if (incotermsUsingPortOfLoading.includes(safeIncoterm)) {
      return `${safeIncoterm} ${portOfLoading || ""}`;
    } else if (incotermsUsingPortOfDischarge.includes(safeIncoterm)) {
      return `${safeIncoterm} ${portOfDischarge || ""}`;
    }
    return ""; 
  };

  const [splitShipment, setSplitShipment] = useState(false);
  const [splitParts, setSplitParts] = useState(1);
  const [splitShipmentData, setSplitShipmentData] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [nicSugarDialogOpen, setNicSugarDialogOpen] = useState(false);

  const [openPoDialog, setOpenPoDialog] = useState(false);
  const [openSoDialog, setOpenSoDialog] = useState(false);
  
  useEffect(() => {
    if (splitShipment) {
      const initialData = Array.from({ length: splitParts }, () => ({
        numberOfCartons: "",
        netWeightPerCarton: "",
        shipmentQuantity: "",
        shipmentETD: "",
        shipmentQuantityUnit:"KG",
        cartonsPerContainer:"",
      }));
      setSplitShipmentData(initialData);
    } else {
      setSplitShipmentData([]);
    }
  }, [splitShipment, splitParts]);

  const updateSplitData = (index, field, value) => {
    const newData = [...splitShipmentData];
    newData[index][field] = value;
    if (field === "numberOfCartons" || field === "netWeightPerCarton") {
      const cartons = parseFloat(newData[index].numberOfCartons);
      const netWeight = parseFloat(newData[index].netWeightPerCarton);
      if (!isNaN(cartons) && !isNaN(netWeight)) {
        newData[index].shipmentQuantity = cartons * netWeight;
      }
    }
    setSplitShipmentData(newData);
  };

  const [stakeholders, setStakeholders] = useState([]);
  const [selectedStakeholder, setSelectedStakeholder] = useState(null);

  const [shippingInstructions, setShippingInstructions] = useState([]);
  const [selectedSi, setSelectedSi] = useState(null);

  const [filterShippingInstruction, setFilterShippingInstruction] = useState({
    id: 0,
    shipmentRequestIdList: [],
    freightOfferIdList: [],
    itemIdList: [],
    shippingInstructionIdList: [],
    purchaseOrderIdList: [],
    salesOrderIdList: [],
    purchaseOrderIncotermList: [],
    salesOrderIncotermList: [],
    transportationContact: "",
    finalShippingInstructionNumber: "",
    cartonNumber: "",
    shippedByList: [],
    billOfLadingNumber: "",
    cmrNumber: "",
    estimatedTimeOfDepartureFrom: null,
    estimatedTimeOfDepartureTo: null,
    estimatedTimeOfArrivalFrom: null,
    estimatedTimeOfArrivalTo: null,
    shipperIdList: [],
    consigneeIdList: [],
    notifyIdList: [],
    pointOfLoadingList: [],
    pointOfUnloadingList: [],
    description: "",
    remark: "",
    shippingInstructionTypeList: ["FVTW", "FVTWCT","FVTWZF", "FWTW", "FWTWCT","FWTWZF",],
    statusList: ["Open","Closed"],
    recordStatusList: ["ACTIVE"],
  });

  const filterWarehouse = {
    recordStatusList: ["ACTIVE"],
  };

  function retrieveFilteredShippingInstructions(filterShippingInstruction) {
    retrieveFastFilteredShippingInstructionsApi(filterShippingInstruction)
      .then((response) => {
        setShippingInstructions(response?.data);
        return response?.data || [];
      })
      .catch((error) => console.log(error.response?.data));
  }

  const [warehouses, setWarehouses] = useState([]);
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);

  function retrieveFilteredWarehouseRecords(filterWarehouse) {
    retrieveFilteredWarehouseRecordsApi(filterWarehouse)
      .then((response) => {
        setWarehouses(response?.data);
        return response?.data || [];
      })
      .catch((error) => console.log(error.response?.data));
  }

  function retrieveStakeholders() {
    Promise.all([
      retrieveFastStakeholdersApi("VENDOR"),
      retrieveFastStakeholdersApi("CUSTOMER"),
    ])
      .then(([vendorResponse, customerResponse]) => {
        setStakeholders([...vendorResponse?.data, ...customerResponse?.data]);
      })
      .catch((error) => console.log(error.response?.data));
  }

  function retrieveOrders(orderType) {
    let filterOrder;
    if(["FWTW", "FWTC", "FWTIMP", "FWTINV", "FWTWCT", "FWTWZF"].includes(addViewStates?.shipmentRequestType)){
       filterOrder = {
        orderType: orderType,
        approvalStatusList: ["Approved"],
        recordStatusList: ["ACTIVE"],
      };
    }else{
       filterOrder = {
        orderType: orderType,
        remainingQuantity: 1,
        approvalStatusList: ["Approved"],
        recordStatusList: ["ACTIVE"],
      };
    }

    retrieveFilteredOrdersApi(filterOrder)
      .then((response) => {
        setOrders(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }
  function retrieveQuantity(itemId) {
    retrieveQuantityByItemIdApi(itemId)
      .then((response) => {
        setQuantity(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

  const tpOptions = [
    {
      value: true,
      label: "Sales",
    },
    {
      value: false,
      label: "Inward",
    },
  ];

  function retrieveFilteredOrders(orderDto) {
    retrieveFilteredOrdersApi(orderDto)
      .then((response) => {
        setOrders(response?.data);
        return response?.data || [];
      })
      .catch((error) => console.log(error.response?.data));
  }

  const orderDto = {
    orderType: "",
    offerId: addViewStates?.offer?.id,
    offerIdList: [] || [],
    itemIdList: [],
    stakeholderIdList: [],
    costIdList: [],
    companyList: [],
    approvalStatusList: ["Approved"],
    customerList: [],
    firstSampleIdList: [],
    secondSampleIdList: [],
    firstSampleStatusList: [],
    secondSampleStatusList: [],
    paymentTermList: [],
    incotermList: [],
    portOfLoadingList: [],
    portOfDischargeList: [],
    packagingList: [],
    volumeUnitList: [],
    firstPriceCurrencyList: [],
    finalPriceCurrencyList: [],
    documentStatusList: [],
    originList: [],
    typeList: [],
    leafFormList: [],
    colorList: [],
    storageList: [],
    orderStatusList: ["Open","","PO Created","SO Created"],
    recordStatusList: ["ACTIVE"],
  };

  const [fvSelected, setFvSelected] = useState(false);
  const [fwSelected, setFwSelected] = useState(false);
  const [tcSelected, setTcSelected] = useState(false);
  const [twSelected, setTwSelected] = useState(false);
  const [tpSelected, setTpSelected] = useState(false);
  const [ctSelected, setCtSelected] = useState(false);
  const [zfSelected, setZfSelected] = useState(false);
  const [fwCtSelected, setFwCtSelected] = useState(false);
  const [fwZfSelected, setFwZfSelected] = useState(false);
  const [tpSales, setTpSales] = useState(false);
  const [orders, setOrders] = useState([]);
  const [quantity, setQuantity] = useState([]);
  const [selectedPo, setSelectedPo] = useState(null);
  const [selectedSo, setSelectedSo] = useState(null);

   const totalPlannedShipmentQty = React.useMemo(
    () =>
      splitShipment
        ? splitShipmentData.reduce(
            (sum, s) => sum + (parseFloat(s?.shipmentQuantity) || 0),
            0,
          )
        : Number(addViewStates?.shipmentQuantity) || 0,
    [splitShipment, splitShipmentData, addViewStates?.shipmentQuantity],
  );

  useEffect(() => {
    if (selectedPo?.estimatedTimeOfDeparture) {
      if (
        addViewStates?.shipmentRequestType === "FVTW" ||
        addViewStates?.shipmentRequestType === "FWTW" ||
        addViewStates?.shipmentRequestType === "FVTWCT" ||
        addViewStates?.shipmentRequestType === "FWTWCT" ||
        addViewStates?.shipmentRequestType === "FVTWZF" ||
        addViewStates?.shipmentRequestType === "FWTWZF" ||
        addViewStates?.shipmentRequestType === "FWTINW" ||
        addViewStates?.shipmentRequestType === "FVTINW"
      ) {
        setAddViewStates({
          ...addViewStates,
          shipmentEstimatedTimeOfDeparture: format(
            parseISO(selectedPo.estimatedTimeOfDeparture),
            "yyyy-MM-dd",
          ),
        });
      }
    }
  }, [selectedPo]);

  // Event handler for checkbox selections
  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    if (name === 'fv') {
      setFvSelected(checked);
      setFwSelected(false);
      setFwCtSelected(false);
      setFwZfSelected(false);
      setSelectedSo(null);
      setSelectedPo(null);
      setSelectedSi(null);
      setCtSelected(null);
      setZfSelected(null);
      setSelectedWarehouse(null);
      setSelectedStakeholder(selectedPo?.offer?.stakeholder || null);
      setAddViewStates({
        ...addViewStates,
        shipmentRequestType:
          "FV" +
          (addViewStates.shipmentRequestType
            ? addViewStates.shipmentRequestType.slice(2)
            : ""),
        shipmentRequestTo: selectedPo?.offer?.stakeholder?.name || "",
        referenceShippingInstructionId: "",
        referenceShippingInstructionNumber: "",
        portOfDischarge: "",
        portOfLoading: "",
        destination: "",
        warehouse: "",
        operation: "",
      });
    } else if (name === "fw") {
      setFvSelected(false);
      setFwSelected(checked);
      setFwCtSelected(false);
      setFwZfSelected(false);
      setCtSelected(null);
      setZfSelected(null);
      setSelectedSo(null);
      setSelectedPo(null);
      setSelectedSi(null);
      setSelectedWarehouse(null);
      setSelectedStakeholder(null);
      setAddViewStates({
        ...addViewStates,
        shipmentRequestType:
          "FW" +
          (addViewStates.shipmentRequestType
            ? addViewStates.shipmentRequestType.slice(2)
            : ""),
        shipmentRequestTo: "",
        portOfDischarge: "",
        portOfLoading: "",
        destination: "",
        warehouse: "",
        operation: "", 
      });
    }
    // NEW FROM-WAREHOUSE CrossTrades
      if (name === "fwct") {
      setFwCtSelected(checked);
      if (checked) setFwZfSelected(false);
      setSelectedSo(null);
      setSelectedPo(null);
      setSelectedSi(null);
      setSelectedWarehouse(null);
      setSelectedStakeholder(null);
       setFilterShippingInstruction({
                    ...filterShippingInstruction,
                    purchaseOrderIdList: [],
                  });
      setAddViewStates({
        ...addViewStates,
        shipmentRequestType:
          "FW" +
          (addViewStates.shipmentRequestType
            ? addViewStates.shipmentRequestType.slice(2)
            : ""),
        shipmentRequestTo: "",
        portOfDischarge: "",
        portOfLoading: "",
        destination: "",
        warehouse: "",
        operation: "", 
      });
    }

    // NEW FROM-WAREHOUSE Zafiris
    if (name === "fwzf") {
      setFwZfSelected(checked);
      if (checked) setFwCtSelected(false);
     setSelectedSo(null);
      setSelectedPo(null);
      setSelectedSi(null);
      setSelectedWarehouse(null);
      setSelectedStakeholder(null);
             setFilterShippingInstruction({
                    ...filterShippingInstruction,
                    purchaseOrderIdList: [],
                  });
      setAddViewStates({
        ...addViewStates,
        shipmentRequestType:
          "FW" +
          (addViewStates.shipmentRequestType
            ? addViewStates.shipmentRequestType.slice(2)
            : ""),
        shipmentRequestTo: "",
        portOfDischarge: "",
        portOfLoading: "",
        destination: "",
        warehouse: "",
        operation: "", 
      });

    }
    if (name === "ct") {
      setCtSelected(checked);
      setZfSelected(null);
      let newShipmentRequestType = addViewStates?.shipmentRequestType;

  if (checked) {
    if (fvSelected) {
      newShipmentRequestType = "FVTWCT";
    } else if (fwSelected) {
      newShipmentRequestType = "FWTWCT";
    }
  } else {
    // Handle unchecking `ct`
    if (fvSelected) {
      newShipmentRequestType = "FVTW";
    } else if (fwSelected) {
      newShipmentRequestType = "FWTW";
    }
  }

  setAddViewStates({
    ...addViewStates,
    shipmentRequestType: newShipmentRequestType,
  });
    }

        if (name === "zf") {
      setZfSelected(checked);
       setCtSelected(null);
      let newShipmentRequestType = addViewStates?.shipmentRequestType;

  if (checked) {
    if (fvSelected) {
      newShipmentRequestType = "FVTWZF";
    } else if (fwSelected) {
      newShipmentRequestType = "FWTWZF";
    }
  } else {
    // Handle unchecking `ct`
    if (fvSelected) {
      newShipmentRequestType = "FVTW";
    } else if (fwSelected) {
      newShipmentRequestType = "FWTW";
    }
  }

  setAddViewStates({
    ...addViewStates,
    shipmentRequestType: newShipmentRequestType,
  });
    }

    if (name === "tc") {
      setTcSelected(checked);
      setTwSelected(false);
      setTpSelected(false);
      setTpSales(false);
      setSelectedSo(null);
      setSelectedPo(null);
      setSelectedSi(null);
      setCtSelected(null);
      setZfSelected(null);
      setSelectedWarehouse(null);
      setSelectedStakeholder(null);
      if (fvSelected) {
        setAddViewStates({
          ...addViewStates,
          shipmentRequestType: "FVTC",
          shipmentRequestTo: "",
          portOfDischarge: "",
          portOfLoading: "",
          destination: "",
          warehouse: "",
          productionTobaccoCode: "",
        });
      } else if (fwSelected) {
        setAddViewStates({
          ...addViewStates,
          shipmentRequestType: "FWTC",
          shipmentRequestTo: "",
          portOfDischarge: "",
          portOfLoading: "",
          destination: "",
          warehouse: "",
          productionTobaccoCode: "",
        });
      } else {
        setAddViewStates({
          ...addViewStates,
          shipmentRequestType: "AATC",
          shipmentRequestTo: "",
          portOfDischarge: "",
          portOfLoading: "",
          destination: "",
          warehouse: "",
        });
      }
    } else if (name === "tw") {
      setTcSelected(false);
      setTwSelected(checked);
      setTpSelected(false);
      setTpSales(false);
      setSelectedSo(null);
      setSelectedPo(null);
      setSelectedSi(null);
      setCtSelected(null);
      setZfSelected(null);
      setSelectedWarehouse(null);
      setSelectedStakeholder(null);
      if (fvSelected) {
        setAddViewStates({
          ...addViewStates,
          shipmentRequestType: "FVTW",
          shipmentRequestTo: "",
          portOfDischarge: "",
          portOfLoading: "",
          destination: "",
          warehouse: "",
        });
      } else if (fwSelected) {
        setAddViewStates({
          ...addViewStates,
          shipmentRequestType: "FWTW",
          shipmentRequestTo: "",
          portOfDischarge: "",
          portOfLoading: "",
          destination: "",
          warehouse: "",
        });
      } else {
        setAddViewStates({
          ...addViewStates,
          shipmentRequestType: "AATW",
          shipmentRequestTo: "",
          portOfDischarge: "",
          portOfLoading: "",
          destination: "",
          warehouse: "",
        });
      }
    } else if (name === "tp") {
      setTcSelected(false);
      setTwSelected(false);
      setTpSelected(checked);
      setTpSales(false);
      setSelectedSo(null);
      setSelectedPo(null);
      setSelectedSi(null);
      setCtSelected(null);
      setZfSelected(null);
      setSelectedWarehouse(null);
      setSelectedStakeholder(null);
      if (fvSelected) {
        setAddViewStates({
          ...addViewStates,
          shipmentRequestType: "FVTP",
          shipmentRequestTo: "",
          portOfDischarge: "",
          portOfLoading: "",
          destination: "",
          warehouse: "",
        });
      } else if (fwSelected) {
        setAddViewStates({
          ...addViewStates,
          shipmentRequestType: "FWTP",
          shipmentRequestTo: "",
          portOfDischarge: "",
          portOfLoading: "",
          destination: "",
          warehouse: "",
        });
      } else {
        setAddViewStates({
          ...addViewStates,
          shipmentRequestType: "AATP",
          shipmentRequestTo: "",
          portOfDischarge: "",
          portOfLoading: "",
          destination: "",
          warehouse: "",
        });
      }
    }
  };

  return (
    <>
      <Stack direcion="column">
        <Typography variant="body1" mb={2}>
          Create New Shipment Request {addViewStates?.shipmentRequestType}
        </Typography>
      
          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                gap: 1.5,
                p: 1,
                border: "1px solid #e0e0e0",
                borderRadius: 1,
                backgroundColor: "#fafafa",
              }}
            >
              <Typography variant="body1" sx={{ fontWeight: 600, mr: 1 }}>
                From:
              </Typography>
              <FormControlLabel
                sx={{ m: 0 }}
                control={
                  <Checkbox
                    size="small"
                    checked={fvSelected}
                    onChange={handleCheckboxChange}
                    name="fv"
                  />
                }
                label="Vendor"
              />
              <FormControlLabel
                sx={{ m: 0 }}
                control={
                  <Checkbox
                    size="small"
                    checked={fwSelected}
                    onChange={handleCheckboxChange}
                    name="fw"
                  />
                }
                label="Warehouse"
              />
              {fwSelected && (
                <FormControlLabel
                  sx={{
                    m: 0,
                    pl: 2,
                    borderLeft: "1px dashed #ccc",
                  }}
                  control={
                    <Checkbox
                      size="small"
                      checked={fwCtSelected}
                      onChange={handleCheckboxChange}
                      name="fwct"
                    />
                  }
                  label="CrossTrades"
                />
              )}
              {fwSelected && (
                <FormControlLabel
                  sx={{ m: 0 }}
                  control={
                    <Checkbox
                      size="small"
                      checked={fwZfSelected}
                      onChange={handleCheckboxChange}
                      name="fwzf"
                    />
                  }
                  label="Zafiris"
                />
              )}
            </Box>
          </Grid>

          
  <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                gap: 1.5,
                p: 1,
                border: "1px solid #e0e0e0",
                borderRadius: 1,
                backgroundColor: "#fafafa",
              }}
            >
              <Typography variant="body1" sx={{ fontWeight: 600, mr: 3.5 }}>
                To:
              </Typography>
              <FormControlLabel
                sx={{ m: 0 }}
                control={
                  <Checkbox
                    size="small"
                    checked={tcSelected}
                    onChange={handleCheckboxChange}
                    name="tc"
                  />
                }
                label="Customer"
              />
              <FormControlLabel
                sx={{ m: 0 }}
                control={
                  <Checkbox
                    size="small"
                    checked={twSelected}
                    onChange={handleCheckboxChange}
                    name="tw"
                  />
                }
                label="Warehouse"
              />
              <FormControlLabel
                sx={{ m: 0 }}
                control={
                  <Checkbox
                    size="small"
                    checked={tpSelected}
                    onChange={handleCheckboxChange}
                    name="tp"
                  />
                }
                label="Production"
              />
              {twSelected && (
                <FormControlLabel
                  sx={{
                    m: 0,
                    pl: 2,
                    borderLeft: "1px dashed #ccc",
                  }}
                  control={
                    <Checkbox
                      size="small"
                      checked={ctSelected}
                      onChange={handleCheckboxChange}
                      name="ct"
                    />
                  }
                  label="CrossTrades"
                />
              )}
              {twSelected && (
                <FormControlLabel
                  sx={{ m: 0 }}
                  control={
                    <Checkbox
                      size="small"
                      checked={zfSelected}
                      onChange={handleCheckboxChange}
                      name="zf"
                    />
                  }
                  label="Zafiris"
                />
              )}
            </Box>
          </Grid>
          
        <Grid container xs={12} spacing="8px">
          {tpSelected && (
            <Grid item xs={12} sm={2}>
              <Typography variant="body2">Production Type</Typography>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                id="outlined-select-incoterm"
                select
                onChange={(e) => {
                  const newValue = e.target.value;
                  setTpSales(newValue);
                  const defaultWarehouseId = newValue ? 7 : 8;
                  const defaultWarehouseName = newValue ? "CTCWHS" : "CTCINW";
                  const newType = fvSelected
                    ? (newValue ? "FVTIMP" : "FVTINW")
                    : fwSelected
                    ? (newValue ? "FWTIMP" : "FWTINW")
                    : (newValue ? "AATIMP" : "AATINW");
                  retrieveFilteredWarehouseRecordsApi(filterWarehouse)
                    .then((response) => {
                      const warehouseData = response?.data || [];
                      setWarehouses(warehouseData);
                      const defaultWarehouse =
                        warehouseData.find((w) => w.id === defaultWarehouseId) ||
                        { id: defaultWarehouseId, code: defaultWarehouseName };
                      setSelectedWarehouse(defaultWarehouse);
                      setAddViewStates({
                        ...addViewStates,
                        shipmentRequestType: newType,
                        destination: defaultWarehouse?.name || defaultWarehouseName,
                      });
                    })
                    .catch((error) => {
                      console.log(error.response?.data);
                      setAddViewStates({
                        ...addViewStates,
                        shipmentRequestType: newType,
                      });
                    });
                }}
              >
                {tpOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          )}
          <Grid item xs={12} sm={11}></Grid>
          {((tcSelected || tpSelected || twSelected) && (!fwCtSelected) && (!fwZfSelected)) && (
            <Grid item xs={12} sm={2}>
              <Typography variant="body2">Entry Purchase Order</Typography>
              <Autocomplete
                options={orders || []}
                getOptionLabel={(option) =>
                  `ID: ${option?.id || ""}, SAP PO Number: ${
                    option?.purchaseOrderNumber || ""
                  }, Vendor: ${option?.stakeholder?.name || ""},
                  Item ID: ${option?.offer?.item?.id || ""}
                  , Grade: ${option?.offer?.item?.buyingGrade || ""},
                   Origin: ${option?.offer?.item?.origin || ""},
                   Crop: ${option?.offer?.item?.crop || ""}`
                }
                value={selectedPo}
                onChange={(event, newValue) => {
                  setSelectedPo(newValue);
                  setSelectedStakeholder(newValue?.offer?.stakeholder || null);
                  setSelectedSi(null);
                  setFilterShippingInstruction({
                    ...filterShippingInstruction,
                    purchaseOrderIdList: [newValue ? newValue.id : ""],
                  });
                  setAddViewStates({
                    ...addViewStates,
                    purchaseOrder: newValue ? newValue : {},
                    purchaseOrderId: newValue ? newValue.id : "",
                    shipmentRequestTo: newValue
                      ? newValue?.offer?.stakeholder?.name
                      : "",
                    productionTobaccoCode: newValue
                      ? newValue?.offer?.item?.tobaccoCode
                      : "",
                  });
                  retrieveQuantity(newValue?.offer?.item?.id);
                }}
                onOpen={() => {
                  if (selectedSo) {
                    orderDto.orderType = "VENDOR";
                    orderDto.itemIdList = [selectedSo?.offer?.item?.id];
                    retrieveFilteredOrders(orderDto);
                  } else {
                    retrieveOrders("VENDOR");
                  }
                }}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                )}
                renderTags={() => null}
              />
              {selectedPo && (
                <Box mt={2}>
                  <Chip
                    label={`ID: ${selectedPo?.id || ""}`}
                    onDelete={() => {
                      setSelectedPo(null);
                      setAddViewStates({
                        ...addViewStates,
                        purchaseOrder: {},
                        purchaseOrderId: "",
                      });
                    }}
                    style={{ marginBottom: "5px" }}
                  />{" "}
                  <br></br>
                  <Chip
                    label={`SAP PO Number: ${
                      selectedPo?.purchaseOrderNumber || ""
                    }`}
                    style={{ marginBottom: "5px" }}
                  />
                  <br></br>
                  <Chip
                    label={`Quantity: ${selectedPo?.volume || ""} ${
                      selectedPo?.volumeUnit || ""
                    }`}
                    style={{ marginBottom: "5px" }}
                  />
                  <br></br>
                  <Chip
                    label={`Supplier: ${
                      selectedPo?.offer?.stakeholder?.name || ""
                    }`}
                    style={{ marginBottom: "5px" }}
                  />
                  <br></br>
                  <Chip
                    label={`Item ID: ${selectedPo?.offer?.item?.id || ""}`}
                    style={{ marginBottom: "5px" }}
                  />
                  <br></br>
                  <Chip
                    label={`ETD: ${
                      selectedPo?.estimatedTimeOfDeparture
                        ? format(
                            parseISO(selectedPo?.estimatedTimeOfDeparture),
                            "yyyy-MM-dd",
                          )
                        : ""
                    }`}
                    style={{ marginBottom: "5px" }}
                  />
                  <br></br>
                  <Chip
                    label={`Unshipped Quantity: ${
                      selectedPo?.remainingQuantity
                        ? `${new Intl.NumberFormat("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 2,
                          }).format(selectedPo.remainingQuantity)} ${
                            selectedPo?.volumeUnit || ""
                          }`
                        : ""
                    }`}
                    style={{ marginBottom: "5px" }}
                  />
                  <br></br>
                </Box>
              )}
              {selectedPo && (
                    <Tooltip title="View Details">
                      <IconButton onClick={() => setOpenPoDialog(true)}>
                        <SearchIcon />
                      </IconButton>
                    </Tooltip>
                  )}
            </Grid>
          )}

<Dialog open={openPoDialog} onClose={() => setOpenPoDialog(false)} maxWidth="md" fullWidth>
  <DialogTitle sx={{
    bgcolor: "#1976d2",
    color: "#fff",
    fontWeight: 700,
    fontSize: 22,
    letterSpacing: 1,
    textAlign: "center",
    borderBottom: "2px solid #1890ff"
  }}>
    Purchase Order Details
  </DialogTitle>
  <DialogContent sx={{ bgcolor: "#f9fafb", p: 3 }}>
    {selectedPo ? (
      <Box sx={{
        background: "#fff",
        borderRadius: 2,
        boxShadow: 2,
        p: 2,
        maxWidth: "1000px",
        mx: "auto"
      }}>
        <Typography variant="h6" sx={{ color: "#1976d2", mb: 2, fontWeight: 700 }}>
          General Info
        </Typography>
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>ID:</Typography><Typography variant="body1">{selectedPo?.id}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Order Year:</Typography><Typography variant="body1">{selectedPo?.orderYear}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>SAP PO Number:</Typography><Typography variant="body1">{selectedPo?.purchaseOrderNumber}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Order Group Number:</Typography><Typography variant="body1">{selectedPo?.orderGroupNumber}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Contract Value Date:</Typography><Typography variant="body1">{selectedPo?.contractValueDate ? format(parseISO(selectedPo?.contractValueDate), "yyyy-MM-dd") : ""}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Vendor:</Typography><Typography variant="body1">{selectedPo?.offer?.stakeholder?.name}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>SAP Vendor Code:</Typography><Typography variant="body1">{selectedPo?.offer?.stakeholder?.code}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Company:</Typography><Typography variant="body1">{selectedPo?.company}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Order Status:</Typography><Typography variant="body1">{selectedPo?.orderStatus}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Record Status:</Typography><Typography variant="body1">{selectedPo?.recordStatus}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Issue Date:</Typography><Typography variant="body1">{selectedPo?.operationDate ? format(parseISO(selectedPo?.operationDate), "yyyy-MM-dd") : ""}</Typography></Grid>
          <Grid item xs={12}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Contract Link:</Typography><Typography variant="body1">{selectedPo?.contractLink}</Typography></Grid>
        </Grid>
        <Divider sx={{ mb: 2 }} />
        <Typography variant="h6" sx={{ color: "#1976d2", mb: 2, fontWeight: 700 }}>
          Offer & Item Details
        </Typography>
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Offer:</Typography><Typography variant="body1">{selectedPo?.offer?.id} - {selectedPo?.offer?.offerYear} - {selectedPo?.offer?.offerGroupNumber}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Buying Grade:</Typography><Typography variant="body1">{selectedPo?.offer?.item?.buyingGrade}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Internal Grade:</Typography><Typography variant="body1">{selectedPo?.offer?.item?.internalGrade}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Sales Grade:</Typography><Typography variant="body1">{selectedPo?.salesGrade}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Origin:</Typography><Typography variant="body1">{selectedPo?.offer?.item?.origin}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Province:</Typography><Typography variant="body1">{selectedPo?.offer?.item?.province}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Crop:</Typography><Typography variant="body1">{selectedPo?.offer?.item?.crop}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Nicotine:</Typography><Typography variant="body1">{selectedPo?.offer?.item?.nicotine}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Sugar:</Typography><Typography variant="body1">{selectedPo?.offer?.item?.sugar}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Moisture:</Typography><Typography variant="body1">{selectedPo?.offer?.item?.moisture}</Typography></Grid>
        </Grid>
        <Divider sx={{ mb: 2 }} />
        <Typography variant="h6" sx={{ color: "#1976d2", mb: 2, fontWeight: 700 }}>
          Quantity & Pricing
        </Typography>
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Number Of Cartons:</Typography><Typography variant="body1">{selectedPo?.numberOfCases}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Net Weight Per Carton:</Typography><Typography variant="body1">{selectedPo?.netWeightPerCase}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Volume:</Typography><Typography variant="body1">{selectedPo?.volume} {selectedPo?.volumeUnit}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Packaging:</Typography><Typography variant="body1">{selectedPo?.packaging}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Final Price:</Typography><Typography variant="body1">{selectedPo?.finalPrice} {selectedPo?.finalPriceCurrency}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Total Amount:</Typography><Typography variant="body1">{selectedPo?.totalAmount}</Typography></Grid>
        </Grid>
        <Divider sx={{ mb: 2 }} />
        <Typography variant="h6" sx={{ color: "#1976d2", mb: 2, fontWeight: 700 }}>
          Terms & Logistics
        </Typography>
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Incoterm:</Typography><Typography variant="body1">{selectedPo?.incoterm}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Payment Term:</Typography><Typography variant="body1">{selectedPo?.paymentTerm}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Port Of Discharge:</Typography><Typography variant="body1">{selectedPo?.portOfDischarge}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Port Of Loading:</Typography><Typography variant="body1">{selectedPo?.portOfLoading}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>ETD:</Typography><Typography variant="body1">{selectedPo?.estimatedTimeOfDeparture ? format(parseISO(selectedPo?.estimatedTimeOfDeparture), "yyyy-MM-dd") : ""}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>ETA:</Typography><Typography variant="body1">{selectedPo?.estimatedTimeOfArrival ? format(parseISO(selectedPo?.estimatedTimeOfArrival), "yyyy-MM-dd") : ""}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Shipment Schedule:</Typography><Typography variant="body1">{selectedPo?.shipmentSchedule}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Shipping Term:</Typography><Typography variant="body1">{selectedPo?.shippingTerm}</Typography></Grid>
        </Grid>
        <Divider sx={{ mb: 2 }} />
        <Typography variant="h6" sx={{ color: "#1976d2", mb: 2, fontWeight: 700 }}>
          Sample & Notes
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Redrawn Sample:</Typography>
            <Typography variant="body1">
              {selectedPo.firstSample
                ? `ID: ${selectedPo.firstSample.id}, Remark: ${selectedPo.firstSample.remark}, Buying Grade: ${selectedPo.firstSample.item?.buyingGrade}`
                : ""}
            </Typography>
          </Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Redrawn Sample Status:</Typography>
            <Typography variant="body1">{selectedPo.firstSampleStatus}</Typography>
          </Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Remark:</Typography>
            <Typography variant="body1">{selectedPo.remark}</Typography>
          </Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Comment:</Typography>
            <Typography variant="body1">{selectedPo.comment}</Typography>
          </Grid>
        </Grid>
      </Box>
    ) : null}
  </DialogContent>
</Dialog>

          {fwSelected && (tcSelected || twSelected || tpSelected) && (
            <Grid item xs={12} sm={2}>
              <Typography variant="body2">Select Reference SI</Typography>
              <Autocomplete
                options={shippingInstructions || []}
                getOptionLabel={(option) =>
                  `ID: ${option?.id || ""}, SI Number: ${
                    option?.finalShippingInstructionNumber || ""
                  }, SR : ${
                    option?.shipmentRequest?.shipmentRequestType || ""
                  }, SR Number: ${option?.shipmentRequest?.id || ""}, Date: ${
                    option?.stakeholder?.name || ""
                  }, POD: ${option?.pointOfUnloading || ""}, Status: ${option?.status || ""}`
                }
                value={selectedSi}
                onChange={(event, newValue) => {
                  setSelectedSi(newValue);
                  setAddViewStates({
                    ...addViewStates,
                    referenceShippingInstruction: newValue ? newValue : {},
                    referenceShippingInstructionId: newValue
                    ? newValue.id
                    : "",
                    referenceShippingInstructionNumber: newValue
                      ? newValue.finalShippingInstructionNumber
                      : "",
                    warehouse: newValue ? newValue?.destination : "",
                  });
                 if (newValue) {
                   const filterWarehouse = {
                     recordStatusList:["ACTIVE"],
                     warehouseList:[newValue?.destination]
                   }
                   retrieveFilteredWarehouseRecordsApi(filterWarehouse)
                     .then((warehouseInfo) => {
                       console.log("warehouseInfo", warehouseInfo?.data[0]);
                       setAddViewStates((prevData) => ({
                         ...prevData,
                         shipmentRequestTo: warehouseInfo?.data[0]?.contactPerson?.name,
                       }));
                       setSelectedStakeholder(warehouseInfo?.data[0]?.contactPerson);
                     })
                     .catch((error) => {
                       console.error("Error fetching warehouse info:", error);
                     });
                 }
                }}
                onOpen={() =>
                  retrieveFilteredShippingInstructions(
                    filterShippingInstruction,
                  )
                }
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                )}
                renderTags={() => null}
                disabled={(!fwCtSelected) && (!fwZfSelected) && (!selectedPo)} 
              />
              {selectedSi && (
                <Box mt={2}>
                  <Chip
                    label={`ID: ${selectedSi?.id || ""}`}
                    onDelete={() => {
                      setSelectedSi(null);
                      setAddViewStates({
                        ...addViewStates,
                        referenceShippingInstruction:{},
                        referenceShippingInstructionNumber: "",
                        referenceShippingInstructionId: null,
                        warehouse: "",
                      });
                    }}
                  />
                </Box>
              )}
            </Grid>
          )}

     {(fwCtSelected || fwZfSelected) && (
            <Grid item xs={12} sm={2}>
              <Typography variant="body2">Entry Purchase Order (FWCT- FWZF)</Typography>
                  <TextField
                   value={selectedSi?.purchaseOrderId ? `ID: ${selectedSi?.purchaseOrderId || ""}, SAP PO Number: ${selectedSi?.purchaseOrderNumber || ""}, Vendor: ${selectedSi?.shipmentRequest?.purchaseOrder?.stakeholder?.name || ""}, Item ID: ${selectedSi?.purchaseOrderItemId || ""}` : ""}
                    variant="outlined"
                    size="small"
                    fullWidth
                    disabled
                     helperText={!(selectedSi) ? "Select Reference SI First" : ""}
                  />
              {selectedSi && (
                    <Tooltip title="View Details">
                      <IconButton onClick={() => setOpenPoDialog(true)}>
                        <SearchIcon />
                      </IconButton>
                    </Tooltip>
                  )}
            </Grid>
          )}

          {((fwCtSelected) || (fwZfSelected)) && (
            <Grid item xs={12} sm={2}>
              <Typography variant="body2">Carry Purchase Order</Typography>
              <Autocomplete
                options={  (orders || []).filter(o =>
          !(fwCtSelected || fwZfSelected) ||
          o.id !== selectedSi?.purchaseOrderId
        )}
                getOptionLabel={(option) =>
                  `ID: ${option?.id || ""}, SAP PO Number: ${
                    option?.purchaseOrderNumber || ""
                  }, Vendor: ${option?.stakeholder?.name || ""},
                  Item ID: ${option?.offer?.item?.id || ""}
                  , Grade: ${option?.offer?.item?.buyingGrade || ""},
                   Origin: ${option?.offer?.item?.origin || ""},
                   Crop: ${option?.offer?.item?.crop || ""}`
                }
                value={selectedPo}
                disabled={!(selectedSi)}
                onChange={(event, newValue) => {
                  setSelectedPo(newValue);
                  setSelectedStakeholder(newValue?.offer?.stakeholder || null);
                  setAddViewStates({
                    ...addViewStates,
                    purchaseOrder: newValue ? newValue : {},
                    purchaseOrderId: newValue ? newValue.id : "",
                    shipmentRequestTo: newValue
                      ? newValue?.offer?.stakeholder?.name
                      : "",
                    productionTobaccoCode: newValue
                      ? newValue?.offer?.item?.tobaccoCode
                      : "",
                  });
                  retrieveQuantity(newValue?.offer?.item?.id);
                }}
                onOpen={() => {
                  if (selectedSo) {
                    orderDto.orderType = "VENDOR";
                    orderDto.itemIdList = [selectedSo?.offer?.item?.id];
                    retrieveFilteredOrders(orderDto);
                  }else if (selectedSi?.purchaseOrderId) {
                    orderDto.orderType = "VENDOR";
                    orderDto.itemIdList = [selectedSi?.purchaseOrderItemId];
                    retrieveFilteredOrders(orderDto);
                  }else {
                    retrieveOrders("VENDOR");
                  }
                }}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    size="small"
                    fullWidth
                    helperText={!(selectedSi) ? "Select Reference SI First" : ""}
                  />
                )}
                renderTags={() => null}
              />
              {selectedPo && (
                <Box mt={2}>
                  <Chip
                    label={`ID: ${selectedPo?.id || ""}`}
                    onDelete={() => {
                      setSelectedPo(null);
                      setAddViewStates({
                        ...addViewStates,
                        purchaseOrder: {},
                        purchaseOrderId: "",
                      });
                    }}
                    style={{ marginBottom: "5px" }}
                  />{" "}
                  <br></br>
                  <Chip
                    label={`SAP PO Number: ${
                      selectedPo?.purchaseOrderNumber || ""
                    }`}
                    style={{ marginBottom: "5px" }}
                  />
                  <br></br>
                  <Chip
                    label={`Quantity: ${selectedPo?.volume || ""} ${
                      selectedPo?.volumeUnit || ""
                    }`}
                    style={{ marginBottom: "5px" }}
                  />
                  <br></br>
                  <Chip
                    label={`Supplier: ${
                      selectedPo?.offer?.stakeholder?.name || ""
                    }`}
                    style={{ marginBottom: "5px" }}
                  />
                  <br></br>
                  <Chip
                    label={`Item ID: ${selectedPo?.offer?.item?.id || ""}`}
                    style={{ marginBottom: "5px" }}
                  />
                  <br></br>
                  <Chip
                    label={`ETD: ${
                      selectedPo?.estimatedTimeOfDeparture
                        ? format(
                            parseISO(selectedPo?.estimatedTimeOfDeparture),
                            "yyyy-MM-dd",
                          )
                        : ""
                    }`}
                    style={{ marginBottom: "5px" }}
                  />
                  <br></br>
                  <Chip
                    label={`Unshipped Quantity: ${
                      selectedPo?.remainingQuantity
                        ? `${new Intl.NumberFormat("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 2,
                          }).format(selectedPo.remainingQuantity)} ${
                            selectedPo?.volumeUnit || ""
                          }`
                        : ""
                    }`}
                    style={{ marginBottom: "5px" }}
                  />
                  <br></br>
                </Box>
              )}
              {selectedPo && (
                    <Tooltip title="View Details">
                      <IconButton onClick={() => setOpenPoDialog(true)}>
                        <SearchIcon />
                      </IconButton>
                    </Tooltip>
                  )}
            </Grid>
          )}

          {(tcSelected || (tpSelected && tpSales) || (twSelected && ctSelected) || (twSelected && zfSelected)) && (
            <Grid item xs={12} sm={2}>
              <Typography variant="body2">Select Sales Order</Typography>
              <Autocomplete
                options={orders || []}
                getOptionLabel={(option) =>
                  `ID: ${option?.id || ""}, SAP SO Number: ${
                    option?.salesOrderNumber || ""
                  }, Customer: ${option?.stakeholder?.name || ""}, 
                  Item ID: ${option?.offer?.item?.id || ""},
                  Buying Grade: ${option?.offer?.item?.buyingGrade || ""},
                  Sales Grade: ${option?.offer?.salesGrade || ""},
                   Origin: ${option?.offer?.item?.origin || ""},
                   Crop: ${option?.offer?.item?.crop || ""}`
                }
                value={selectedSo}
                onChange={(event, newValue) => {
                  setSelectedSo(newValue);
                  const newDestination = determineDestination(
                    newValue?.incoterm || "",
                    addViewStates?.portOfLoading,
                    addViewStates?.portOfDischarge
                  );
                  setAddViewStates((prev) => ({
                    ...prev,
                    salesOrder: newValue ? newValue : {},
                    salesOrderId: newValue ? newValue.id : "",
                    destination: tcSelected ? newDestination : prev.destination,
                    portOfLoading: newValue?.portOfLoading ? newValue.portOfLoading : "",
                    portOfDischarge: newValue?.portOfDischarge ? newValue.portOfDischarge : "",
                    customerGradeMark: newValue?.offer?.salesGrade || "",
                    productionTobaccoCode: newValue?.offer?.item?.tobaccoCode || "",
                  }));
                  retrieveQuantity(newValue?.offer?.item?.id);
                }}
                onOpen={() => {
                  if (selectedPo) {
                    orderDto.orderType = "CUSTOMER";
                    orderDto.itemIdList = [selectedPo?.offer?.item?.id];
                    retrieveFilteredOrders(orderDto);
                  } else if (selectedSi?.salesOrderId) {
                    orderDto.orderType = "CUSTOMER";
                    orderDto.itemIdList = [selectedSi?.salesOrderItemId];
                    retrieveFilteredOrders(orderDto);
                  } else {
                    retrieveOrders("CUSTOMER");
                  }
                }}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                )}
                renderTags={() => null}
              />
              {selectedSo && (
                <Box mt={2}>
                  <Chip
                    label={`ID: ${selectedSo?.id || ""}`}
                    onDelete={() => {
                      setSelectedSo(null);
                      setAddViewStates({ ...addViewStates, salesOrder:{}, salesOrderId: "" });
                    }}
                    style={{ marginBottom: "5px" }}
                  />{" "}
                  <br></br>
                  <Chip
                    label={`SAP SO Number: ${
                      selectedSo?.salesOrderNumber || ""
                    }`}
                    style={{ marginBottom: "5px" }}
                  />
                  <br></br>
                  <Chip
                    label={`Quantity: ${selectedSo?.volume || ""} ${
                      selectedSo?.volumeUnit || ""
                    }`}
                    style={{ marginBottom: "5px" }}
                  />
                  <br></br>
                  <Chip
                    label={`Redrawn Status: ${
                      selectedSo?.secondSampleStatus || ""
                    }`}
                    style={{ marginBottom: "5px" }}
                  />
                  <br></br>
                  <Chip
                    label={`Customer: ${
                      selectedSo?.offer?.stakeholder?.name || ""
                    }`}
                    style={{ marginBottom: "5px" }}
                  />
                  <br></br>
                  <Chip
                    label={`Customer Grade Mark: ${
                      selectedSo?.offer?.salesGrade || ""
                    }`}
                    style={{ marginBottom: "5px" }}
                  />
                  <br></br>
                  <Chip
                    label={`Item ID: ${selectedSo?.offer?.item?.id || ""}`}
                    style={{ marginBottom: "5px" }}
                  />
                  <br></br>
                  <Chip
                    label={`ETD: ${
                      selectedSo?.estimatedTimeOfDeparture
                        ? format(
                            parseISO(selectedSo?.estimatedTimeOfDeparture),
                            "yyyy-MM-dd",
                          )
                        : ""
                    }`}
                    style={{ marginBottom: "5px" }}
                  />
                  <br></br>
                  <Chip
                    label={`Unshipped Quantity: ${
                      selectedSo?.remainingQuantity
                        ? `${new Intl.NumberFormat("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 2,
                          }).format(selectedSo.remainingQuantity)} ${
                            selectedSo?.volumeUnit || ""
                          }`
                        : ""
                    }`}
                    style={{ marginBottom: "5px" }}
                  />
                  <br></br>
                </Box>
              )}
                {selectedSo && (
                              <Tooltip title="View Details">
                                <IconButton onClick={() => setOpenSoDialog(true)}>
                                  <SearchIcon />
                                </IconButton>
                              </Tooltip>
                            )}
            </Grid>
          )}

          <Dialog open={openSoDialog} onClose={() => setOpenSoDialog(false)} maxWidth="md" fullWidth>
            <DialogTitle sx={{
              bgcolor: "#232f3e",
              color: "#fff",
              fontWeight: 700,
              fontSize: 22,
              letterSpacing: 1,
              textAlign: "center",
              borderBottom: "2px solid #1976d2"
            }}>
              Sales Order Details
            </DialogTitle>
            <DialogContent sx={{ bgcolor: "#f9fafb", p: 3 }}>
              {selectedSo ? (
                <Box sx={{
                  background: "#fff",
                  borderRadius: 2,
                  boxShadow: 2,
                  p: 2,
                  maxWidth: "1000px",
                  mx: "auto"
                }}>
                  <Typography variant="h6" sx={{ color: "#1976d2", mb: 2, fontWeight: 700 }}>
                    General Info
                  </Typography>
                  <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>ID:</Typography><Typography variant="body1">{selectedSo.id}</Typography></Grid>
                    <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Order Year:</Typography><Typography variant="body1">{selectedSo.orderYear}</Typography></Grid>
                    <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>SAP SO Number:</Typography><Typography variant="body1">{selectedSo.salesOrderNumber}</Typography></Grid>
                    <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Order Group Number:</Typography><Typography variant="body1">{selectedSo.orderGroupNumber}</Typography></Grid>
                    <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Contract Value Date:</Typography><Typography variant="body1">{selectedSo.contractValueDate ? format(parseISO(selectedSo.contractValueDate), "yyyy-MM-dd") : ""}</Typography></Grid>
                    <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Customer:</Typography><Typography variant="body1">{selectedSo.offer?.stakeholder?.name}</Typography></Grid>
                    <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>SAP Customer Code:</Typography><Typography variant="body1">{selectedSo.offer?.stakeholder?.code}</Typography></Grid>
                    <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Company:</Typography><Typography variant="body1">{selectedSo.company}</Typography></Grid>
                    <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Order Status:</Typography><Typography variant="body1">{selectedSo.orderStatus}</Typography></Grid>
                    <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Record Status:</Typography><Typography variant="body1">{selectedSo.recordStatus}</Typography></Grid>
                    <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Issue Date:</Typography><Typography variant="body1">{selectedSo.operationDate ? format(parseISO(selectedSo.operationDate), "yyyy-MM-dd") : ""}</Typography></Grid>
                    <Grid item xs={12}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Contract Link:</Typography><Typography variant="body1">{selectedSo.contractLink}</Typography></Grid>
                  </Grid>
                  <Divider sx={{ mb: 2 }} />
                  <Typography variant="h6" sx={{ color: "#1976d2", mb: 2, fontWeight: 700 }}>
                    Offer & Item Details
                  </Typography>
                  <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Offer:</Typography><Typography variant="body1">{selectedSo.offer?.id} - {selectedSo.offer?.offerYear} - {selectedSo.offer?.offerGroupNumber}</Typography></Grid>
                    <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Buying Grade:</Typography><Typography variant="body1">{selectedSo.offer?.item?.buyingGrade}</Typography></Grid>
                    <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Internal Grade:</Typography><Typography variant="body1">{selectedSo.offer?.item?.internalGrade}</Typography></Grid>
                    <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Sales Grade:</Typography><Typography variant="body1">{selectedSo.salesGrade}</Typography></Grid>
                    <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Origin:</Typography><Typography variant="body1">{selectedSo.offer?.item?.origin}</Typography></Grid>
                    <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Province:</Typography><Typography variant="body1">{selectedSo.offer?.item?.province}</Typography></Grid>
                    <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Crop:</Typography><Typography variant="body1">{selectedSo.offer?.item?.crop}</Typography></Grid>
                    <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Nicotine:</Typography><Typography variant="body1">{selectedSo.offer?.item?.nicotine}</Typography></Grid>
                    <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Sugar:</Typography><Typography variant="body1">{selectedSo.offer?.item?.sugar}</Typography></Grid>
                    <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Moisture:</Typography><Typography variant="body1">{selectedSo.offer?.item?.moisture}</Typography></Grid>
                  </Grid>
                  <Divider sx={{ mb: 2 }} />
                  <Typography variant="h6" sx={{ color: "#1976d2", mb: 2, fontWeight: 700 }}>
                    Quantity & Pricing
                  </Typography>
                  <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Number Of Cartons:</Typography><Typography variant="body1">{selectedSo.numberOfCases}</Typography></Grid>
                    <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Net Weight Per Carton:</Typography><Typography variant="body1">{selectedSo.netWeightPerCase}</Typography></Grid>
                    <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Volume:</Typography><Typography variant="body1">{selectedSo.volume}</Typography></Grid>
                    <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Unit:</Typography><Typography variant="body1">{selectedSo.volumeUnit}</Typography></Grid>
                    <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Packaging:</Typography><Typography variant="body1">{selectedSo.packaging}</Typography></Grid>
                    <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Final Price:</Typography><Typography variant="body1">{selectedSo.finalPrice}</Typography></Grid>
                    <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Currency:</Typography><Typography variant="body1">{selectedSo.finalPriceCurrency}</Typography></Grid>
                    <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Total Amount:</Typography><Typography variant="body1">{selectedSo.totalAmount}</Typography></Grid>
                  </Grid>
                  <Divider sx={{ mb: 2 }} />
                  <Typography variant="h6" sx={{ color: "#1976d2", mb: 2, fontWeight: 700 }}>
                    Terms & Logistics
                  </Typography>
                  <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Incoterm:</Typography><Typography variant="body1">{selectedSo.incoterm}</Typography></Grid>
                    <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Payment Term:</Typography><Typography variant="body1">{selectedSo.paymentTerm}</Typography></Grid>
                    <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Port Of Discharge:</Typography><Typography variant="body1">{selectedSo.portOfDischarge}</Typography></Grid>
                    <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Port Of Loading:</Typography><Typography variant="body1">{selectedSo.portOfLoading}</Typography></Grid>
                    <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>ETD:</Typography><Typography variant="body1">{selectedSo.estimatedTimeOfDeparture ? format(parseISO(selectedSo.estimatedTimeOfDeparture), "yyyy-MM-dd") : ""}</Typography></Grid>
                    <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>ETA:</Typography><Typography variant="body1">{selectedSo.estimatedTimeOfArrival ? format(parseISO(selectedSo.estimatedTimeOfArrival), "yyyy-MM-dd") : ""}</Typography></Grid>
                    <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Shipment Schedule:</Typography><Typography variant="body1">{selectedSo.shipmentSchedule}</Typography></Grid>
                    <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Shipping Term:</Typography><Typography variant="body1">{selectedSo.shippingTerm}</Typography></Grid>
                  </Grid>
                  <Divider sx={{ mb: 2 }} />
                  <Typography variant="h6" sx={{ color: "#1976d2", mb: 2, fontWeight: 700 }}>
                    Sample & Notes
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Redrawn Sample:</Typography>
                      <Typography variant="body1">
                        {selectedSo.firstSample
                          ? `ID: ${selectedSo.firstSample.id}, Remark: ${selectedSo.firstSample.remark}, Buying Grade: ${selectedSo.firstSample.item?.buyingGrade}`
                          : ""}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Redrawn Sample Status:</Typography>
                      <Typography variant="body1">{selectedSo.firstSampleStatus}</Typography>
                    </Grid>
                    <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Remark:</Typography>
                      <Typography variant="body1">{selectedSo.remark}</Typography>
                    </Grid>
                    <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Comment:</Typography>
                      <Typography variant="body1">{selectedSo.comment}</Typography>
                    </Grid>
                    <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Description Of Goods:</Typography>
                      <Typography variant="body1">{selectedSo.descriptionOfGoods}</Typography>
                    </Grid>
                    <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Customer Reference:</Typography>
                      <Typography variant="body1">{selectedSo.customerReference}</Typography>
                    </Grid>
                  </Grid>
                </Box>
              ) : null}
            </DialogContent>
          </Dialog>

          {(selectedSo || selectedPo || selectedSi) && (
            <Grid item xs={12} sm={2}>
              <Typography variant="body2">Item</Typography>
              <TextField
                disabled
                type="number"
                variant="outlined"
                size="small"
                fullWidth
                value={
                  selectedSo?.offer?.item?.id ||
                  selectedPo?.offer?.item?.id ||
                  selectedSi?.salesOrderItemId ||
                  selectedSi?.purchaseOrderItemId ||
                  ""
                }
              />
              {(selectedSo || selectedPo || selectedSi) && (
                <Box mt={2}>
                  <Chip
                    label={`ID: ${selectedSo?.offer?.item?.id ||
                      selectedPo?.offer?.item?.id ||
                      selectedSi?.salesOrderItemId ||
                      selectedSi?.purchaseOrderItemId ||
                      ""
                      }`}
                    style={{ marginBottom: "5px" }}
                  />{" "}
                  <br></br>
                  <Chip
                    label={`Origin: ${selectedSo?.offer?.item?.origin ||
                      selectedPo?.offer?.item?.origin ||
                      selectedSi?.salesOrderItemOrigin ||
                      selectedSi?.purchaseOrderItemOrigin ||
                      ""
                      }`}
                    style={{ marginBottom: "5px" }}
                  />
                  <br></br>
                  <Chip
                    label={`Type: ${selectedSo?.offer?.item?.type ||
                      selectedPo?.offer?.item?.type ||
                      selectedSi?.salesOrderItemType ||
                      selectedSi?.purchaseOrderItemType ||
                      ""
                      }`}
                    style={{ marginBottom: "5px" }}
                  />
                  <br></br>
                  <Chip
                    label={`Buying Grade: ${selectedSo?.offer?.item?.buyingGrade ||
                      selectedPo?.offer?.item?.buyingGrade ||
                      selectedSi?.salesOrderItemBuyingGrade ||
                      selectedSi?.purchaseOrderItemBuyingGrade ||
                      ""
                      }`}
                    style={{ marginBottom: "5px" }}
                  />
                  <br></br>
                  <Chip
                    label={`Sales Grade: ${selectedSo?.offer?.item?.salesGrade ||
                      selectedPo?.offer?.item?.salesGrade ||
                      selectedSi?.shipmentRequest?.salesOrder?.offer?.item?.salesGrade ||
                      selectedSi?.shipmentRequest?.purchaseOrder?.offer?.item?.salesGrade ||
                      ""
                      }`}
                    style={{ marginBottom: "5px" }}
                  />
                  <br></br>
                  <Chip
                    label={`Crop: ${selectedSo?.offer?.item?.crop ||
                      selectedPo?.offer?.item?.crop ||
                      selectedSi?.salesOrderItemCrop ||
                      selectedSi?.purchaseOrderItemCrop ||
                      ""
                      }`}
                    style={{ marginBottom: "5px" }}
                  />
                  <br></br>
                  <br></br>
                  <Chip
                    label={`Remaining Quantity: ${quantity?.quantityRemainingInNetKg || ""
                      } KG`}
                    style={{ marginBottom: "5px" }}
                  />
                  <br></br>
                </Box>
              )}
            </Grid>
          )}
          {(tcSelected || tpSelected || twSelected) && (
            <Grid item xs={12} sm={2}>
              <Typography variant="body2">SI To</Typography>
              <Autocomplete
                options={stakeholders}
                getOptionLabel={(option) =>
                  `${option.id || ""} - ${option.type || ""} - ${option.name || ""
                  }`
                }
                value={selectedStakeholder}
                disabled={
                  addViewStates?.shipmentRequestType === "FVTC" ||
                  addViewStates?.shipmentRequestType === "FVTW" ||
                  addViewStates?.shipmentRequestType === "FVTWCT" ||
                  addViewStates?.shipmentRequestType === "FVTWZF" ||
                  addViewStates?.shipmentRequestType === "FVTP" ||
                  addViewStates?.shipmentRequestType === "FVTIMP" ||
                  addViewStates?.shipmentRequestType === "FVTINW"
                }
                onChange={(event, newValue) => {
                  setSelectedStakeholder(newValue);
                  setAddViewStates({
                    ...addViewStates,
                    shipmentRequestTo: newValue ? newValue?.name : null,
                  });
                }}
                onOpen={retrieveStakeholders}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    size="small"
                    fullWidth
                    disabled={
                      addViewStates?.shipmentRequestType === "FVTC" ||
                      addViewStates?.shipmentRequestType === "FVTW" ||
                      addViewStates?.shipmentRequestType === "FVTWCT" ||
                      addViewStates?.shipmentRequestType === "FVTWZF" ||
                      addViewStates?.shipmentRequestType === "FVTP" ||
                      addViewStates?.shipmentRequestType === "FVTIMP" ||
                      addViewStates?.shipmentRequestType === "FVTINW"
                    }
                    value={selectedStakeholder?.name || ""}
                  />
                )}
                renderTags={() => null}
              />
              {selectedStakeholder && (
                <Box mt={2}>
                  <Chip
                    label={`ID: ${selectedStakeholder?.id || ""}`}
                    style={{ marginBottom: "5px" }}
                    disabled={
                      addViewStates?.shipmentRequestType === "FVTC" ||
                      addViewStates?.shipmentRequestType === "FVTW" ||
                      addViewStates?.shipmentRequestType === "FVTWCT" ||
                      addViewStates?.shipmentRequestType === "FVTWZF" ||
                      addViewStates?.shipmentRequestType === "FVTP" ||
                      addViewStates?.shipmentRequestType === "FVTIMP" ||
                      addViewStates?.shipmentRequestType === "FVTINW"
                    }
                    onDelete={() => setSelectedStakeholder(null)}
                  />
                  <br />
                  <Chip
                    label={`Type: ${selectedStakeholder?.type || ""}`}
                    style={{ marginBottom: "5px" }}
                  />
                  <br />
                  <Chip
                    label={`Name: ${selectedStakeholder?.name || ""}`}
                    style={{ marginBottom: "5px" }}
                  />
                  <br />
                </Box>
              )}
            </Grid>
          )}

          {/*{tpSelected && (
            <Grid item xs={12} sm={2}>
              <Typography variant="body2">Production Tobacco Code</Typography>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                value={addViewStates?.productionTobaccoCode || ""}
                onChange={(e) => {
                  setAddViewStates({
                    ...addViewStates,
                    productionTobaccoCode: e.target.value,
                  });
                }}
              />
            </Grid>
          )}*/}

          {(tcSelected || tpSelected || twSelected) && (
            <Grid item xs={12} sm={2}>
              <Typography variant="body2">Customer Grade Mark</Typography>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                value={addViewStates?.customerGradeMark || ""}
                onChange={(e) => {
                  setAddViewStates({
                    ...addViewStates,
                    customerGradeMark: e.target.value,
                  });
                }}
              />
            </Grid>
          )}

           {fwSelected &&
            (tcSelected || twSelected || tpSelected) &&
            selectedSi && (
              <Grid item xs={12} sm={2}>
                <Typography variant="body2">Warehouse</Typography>
                <TextField
                  variant="outlined"
                  size="small"
                  fullWidth
                  disabled
                  id="outlined-select-pol"
                  value={selectedSi?.destination}
                />
              </Grid>
            )}

          {tcSelected && (
            <Grid item xs={12} sm={2}>
              <Typography variant="body2">Destination</Typography>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                value={addViewStates?.destination || ""}
                onChange={(e) => {
                  setAddViewStates({
                    ...addViewStates,
                    destination: e.target.value,
                  });
                }}
              />
            </Grid>
          )}

          {(tpSelected || twSelected) && (
            <Grid item xs={12} sm={2}>
              <Typography variant="body2">Destination</Typography>
              <Autocomplete
                options={warehouses || []}
                getOptionLabel={(option) =>
                  `ID: ${option?.id || ""}, Code: ${
                    option?.code || ""
                  }, Name: ${option?.name || ""}`
                }
                value={selectedWarehouse}
                onChange={(event, newValue) => {
                  setSelectedWarehouse(newValue);
                  setAddViewStates({
                    ...addViewStates,
                    destination: newValue ? newValue?.name : "",
                  });
                }}
                onOpen={() => retrieveFilteredWarehouseRecords(filterWarehouse)}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    size="small"
                    fullWidth
                    error={!addViewStates?.destination}
                    helperText={!addViewStates?.destination ? "Select A Warehouse as Destination" : ""}
                  />
                )}
                renderTags={() => null}
              />
              {selectedWarehouse && (
                <Box mt={2}>
                  <Chip
                    label={`ID: ${selectedWarehouse?.id || ""}`}
                    onDelete={() => {
                      setSelectedWarehouse(null);
                      setAddViewStates({ ...addViewStates, destination: "" });
                    }}
                    style={{ marginBottom: "5px" }}
                  />
                  <br></br>
                  <Chip
                    label={`Code: ${selectedWarehouse?.code || ""}`}
                    style={{ marginBottom: "5px" }}
                  />
                  <br />
                  <Chip
                    label={`Name: ${selectedWarehouse?.name || ""}`}
                    style={{ marginBottom: "5px" }}
                  />
                  <br />
                  <Chip
                    label={`Contact: ${
                      selectedWarehouse?.warehouseContactPerson?.name || ""
                    }`}
                    style={{ marginBottom: "5px" }}
                  />
                  <br />
                  <Chip
                    label={`Storage Pricing By ${
                      selectedWarehouse?.storagePricingBy || ""
                    }`}
                    style={{ marginBottom: "5px" }}
                  />
                  <br />
                </Box>
              )}
            </Grid>
          )}

          {/*(tpSelected || twSelected) && (
            <Grid item xs={12} sm={2}>
              <WarehouseInventoryButton
                warehouse={addViewStates?.destination}
                itemIdList={[
                  selectedPo?.offer?.item?.id || 0,
                  selectedSo?.offer?.item?.id || 0,
                ]}
              />
            </Grid>
          )*/}

          {(tcSelected || tpSelected || twSelected) && (
            <Grid item xs={12} sm={2}>
              <Typography variant="body2">Port Of Loading</Typography>
               <FilterSelect
                    menuType="portsOfLoading"
                    value={addViewStates?.portOfLoading || ""}
                   onChange={(e) => {
                  const updatedPOL = e.target.value;
                
                  const newDestination = tcSelected
                    ? determineDestination(
                        selectedSo?.incoterm || "",
                        updatedPOL,
                        addViewStates?.portOfDischarge
                      )
                    : addViewStates?.destination;
                
                  setAddViewStates({
                    ...addViewStates,
                    portOfLoading: updatedPOL,
                    destination: newDestination,
                  });
                }}
                    fullWidth
                  />
            </Grid>
          )}

          {(tcSelected || tpSelected || twSelected) && (
            <Grid item xs={12} sm={2}>
              <Typography variant="body2">Port Of Discharge</Typography>
              <FilterSelect
                menuType="portsOfDischarge"
                value={addViewStates?.portOfDischarge || ""}
                onChange={(e) => {
                  const updatedPOD = e.target.value;
                  const newDestination = tcSelected
                    ? determineDestination(
                        selectedSo?.incoterm || "",
                        addViewStates?.portOfLoading,
                        updatedPOD
                      )
                    : addViewStates?.destination;
                
                  setAddViewStates({
                    ...addViewStates,
                    portOfDischarge: updatedPOD,
                    destination: newDestination, 
                  });
                }}
                fullWidth
              />
            </Grid>
          )}

{(tcSelected || tpSelected || twSelected) && (
            <Grid item xs={12}>
               <Typography variant="body2" sx={{ mb: 1 }}>
      Number of Shipments:
    </Typography>
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
    <Button
      variant={splitShipment ? "contained" : "outlined"}
      onClick={() => setSplitShipment(!splitShipment)}
      sx={{ mr: 2 }}
    >
      {splitShipment ? "Disable Split" : "Enable Split"}
    </Button>
    {splitShipment && (
      <>
        <TextField
          type="number"
          size="small"
          value={splitParts}
          helperText={splitParts>=10 ? "Max 10 Shipments" : ""}
          onWheel={(e) => e.target.blur()}
          onChange={(e) => {
            let value = Number(e.target.value);
            if (value > 10) value = 10;
            setSplitParts(value);
          }}
          inputProps={{ min: 1 }}
          sx={{ width: 150 }}
        />
      </>
    )}
  </Box>
              {splitShipment ? (
                <>
                  <Divider sx={{ my: 2 }} />
                  <Typography variant="h6" sx={{ mb: 2 }}>
                    Split Shipment Details
                  </Typography>
                  {splitShipmentData.map((split, index) => (
                    <Card
                      key={index}
                      variant="outlined"
                      sx={{ p: 2, mb: 2, borderRadius: 2 }}
                    >
                      <Typography variant="subtitle1" sx={{ mb: 1 }}>
                        Part {index + 1}
                      </Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={2}>
                          <TextField
                            label="No. of Cartons"
                            type="number"
                            size="small"
                            fullWidth
                            value={split.numberOfCartons}
                            onWheel={(e) => e.target.blur()}
                            onChange={(e) =>
                              updateSplitData(index, "numberOfCartons", e.target.value)
                            }
                          />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                          <TextField
                            label="Net Weight Per Carton"
                            type="number"
                            size="small"
                            fullWidth
                            value={split.netWeightPerCarton}
                            onWheel={(e) => e.target.blur()}
                            onChange={(e) =>
                              updateSplitData(index, "netWeightPerCarton", e.target.value)
                            }
                          />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                          <TextField
                            label="Shipment Quantity"
                            type="number"
                            size="small"
                            fullWidth
                            value={split.shipmentQuantity}
                            onWheel={(e) => e.target.blur()}
                            onChange={(e) =>
                              updateSplitData(index, "shipmentQuantity", e.target.value)
                            }
                          />
                        </Grid>
                        <Grid item xs={12} sm={1}>
                          <FilterSelect
                               menuType="unit"
                               value={split.shipmentQuantityUnit || "KG"}
                                onChange={(e) =>
                            updateSplitData(index, "shipmentQuantityUnit", e.target.value)
                          }
                               fullWidth
                             />
                       </Grid>
                       <Grid item xs={12} sm={2}>
                          <TextField
                            label="Cartons Per Container"
                            type="number"
                            variant="outlined"
                            size="small"
                            fullWidth
                            value={split.cartonsPerContainer}
                            onWheel={(e) => e.target.blur()}
                            onChange={(e) =>
                              updateSplitData(index, "cartonsPerContainer", e.target.value)
                            }
                          />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                          <TextField
                            label="Shipment ETD"
                            type="date"
                            size="small"
                            fullWidth
                            value={split.shipmentETD}
                            onKeyDown={(e) => e.preventDefault()}
                            onChange={(e) =>
                              updateSplitData(index, "shipmentETD", e.target.value)
                            }
                            InputLabelProps={{ shrink: true }}
                           >
                        </TextField>
                        </Grid>
                      </Grid>
                    </Card>
                  ))}
                  <Grid container spacing={2} sx={{ mt: 2 }}>
                    <Grid item xs={12} sm={2}>
                      <Box sx={{ textAlign: "center" }}>
                        <Typography variant="h6" color="primary" sx={{ fontWeight: "bold" }}>
                          Total Number of Cartons {splitShipmentData.reduce(
                            (total, split) => total + (parseFloat(split.numberOfCartons) || 0),
                            0
                          )}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={2}></Grid>
                    <Grid item xs={12} sm={2}>
                      <Box sx={{ textAlign: "center" }}>
                        <Typography variant="h6" color="primary" sx={{ fontWeight: "bold" }}>
                          Total Shipment Quantity {splitShipmentData.reduce(
                            (total, split) => total + (parseFloat(split.shipmentQuantity) || 0),
                            0
                          )}{" "}
                          KG
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </>
              ) : (
                <Grid container spacing={2}>
         
            <Grid item xs={12} sm={2}>
              <Typography variant="body2">Number Of Cartons</Typography>
              <TextField
                type="number"
                variant="outlined"
                size="small"
                fullWidth
                onWheel={(e) => e.target.blur()}
                onChange={(e) =>
                  setAddViewStates({
                    ...addViewStates,
                    numberOfCases: e.target.value,
                    shipmentQuantity:
                      e.target.value * addViewStates?.netWeightPerCase,
                  })
                }
              />
            </Grid>
        
            <Grid item xs={12} sm={2}>
              <Typography variant="body2">Net Weight Per Carton</Typography>
              <TextField
                type="number"
                variant="outlined"
                size="small"
                fullWidth
                onWheel={(e) => e.target.blur()}
                onChange={(e) =>
                  setAddViewStates({
                    ...addViewStates,
                    netWeightPerCase: e.target.value,
                    shipmentQuantity:
                      e.target.value * addViewStates?.numberOfCases,
                  })
                }
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <Typography variant="body2">Shipment Quantity</Typography>
              <TextField
                type="number"
                variant="outlined"
                size="small"
                fullWidth
                value={addViewStates?.shipmentQuantity}
                onWheel={(e) => e.target.blur()}
                onChange={(e) => {
                  if (e.target.value > selectedSo?.volume) {
                    toast.error(
                      "Shipment quantity cannot be greater than SO Quantity!",
                    );
                  } else {
                    setAddViewStates({
                      ...addViewStates,
                      shipmentQuantity: e.target.value,
                    });
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <Typography variant="body2">Unit</Typography>
              <FilterSelect
                   menuType="unit"
                   value={addViewStates?.shipmentQuantityUnit || "KG"}
                   onChange={(e) =>
                   setAddViewStates({
                     ...addViewStates,
                     shipmentQuantityUnit: e.target.value,
                   })
                 }
                   fullWidth
                 />
            </Grid>

            <Grid item xs={12} sm={2}>
              <Typography variant="body2">Cartons Per Container</Typography>
              <TextField
                type="number"
                variant="outlined"
                size="small"
                fullWidth
                onWheel={(e) => e.target.blur()}
                onChange={(e) =>
                  setAddViewStates({
                    ...addViewStates,
                    cartonsPerContainer: e.target.value,
                  })
                }
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <Typography variant="body2">Shipment ETD</Typography>
              <TextField
                size="small"
                fullWidth
                variant="outlined"
                id="date"
                type="date"
                inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                onKeyDown={(e) => e.preventDefault()}
                value={
                  addViewStates?.shipmentEstimatedTimeOfDeparture
                    ? format(
                        parseISO(
                          addViewStates.shipmentEstimatedTimeOfDeparture,
                        ),
                        "yyyy-MM-dd",
                      )
                    : ""
                }
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(e) =>
                  setAddViewStates({
                    ...addViewStates,
                    shipmentEstimatedTimeOfDeparture: e.target.value,
                  })
                }
              />
            </Grid>
            </Grid>
              )}
            </Grid>
          )}

          {(tcSelected || tpSelected || twSelected) && (
            <Grid item xs={12} sm={2}>
              <Typography variant="body2">Approval Status</Typography>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                disabled
                id="outlined-select-approval-status"
                defaultValue={"Not Approved"}
              ></TextField>
            </Grid>
          )}

          {(tcSelected || tpSelected || twSelected) && (
            <Grid item xs={12} sm={2}>
              <Typography variant="body2">Loading Remark</Typography>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                onChange={(e) =>
                  setAddViewStates({
                    ...addViewStates,
                    loadingRemark: e.target.value,
                  })
                }
              />
            </Grid>
          )}
          {(tcSelected || tpSelected || twSelected) && (
            <Grid item xs={12} sm={2}>
              <Typography variant="body2">Remark</Typography>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                onChange={(e) =>
                  setAddViewStates({
                    ...addViewStates,
                    remark: e.target.value,
                  })
                }
              />
            </Grid>
          )}
          {(tcSelected || tpSelected || twSelected) && (
            <Grid item xs={12} sm={2}>
              <Typography variant="body2">Status</Typography>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                id="outlined-select-status"
                select
                disabled
                label={"Open"}
              >
              </TextField>
            </Grid>
          )}

          {(tcSelected || tpSelected || twSelected) && (
            <Grid item xs={12} sm={2}>
              <Typography variant="body2">Record Status</Typography>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                id="outlined-select-record-status"
                select
                disabled
                label={"ACTIVE"}
              >
              </TextField>
            </Grid>
          )}
        </Grid>
        <Stack direction="row" spacing={1} mt={1}>
          <Button variant="outlined" 
          disabled={isSaving}
          onClick={() => setAddView(false)}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              // Quantity checks first
              if (
                /^FW.*/.test(addViewStates?.shipmentRequestType) &&
                quantity?.quantityRemainingInWarehouseInNetKg - totalPlannedShipmentQty < 0
              ) {
                alert(`Selected item's:\n\nRemaining quantity in vendor: ${quantity?.quantityRemainingInVendorInNetKg || "N/A"} KG\nRemaining quantity in warehouse: ${quantity?.quantityRemainingInWarehouseInNetKg || "N/A"} KG\nRemaining quantity in production: ${quantity?.quantityRemainingInProductionInNetKg || "N/A"} KG`);
              } else if (
                /^FV.*/.test(addViewStates?.shipmentRequestType) &&
                quantity?.quantityRemainingInVendorInNetKg - totalPlannedShipmentQty < 0
              ) {
                alert(`Selected item's:\n\nRemaining quantity in vendor: ${quantity?.quantityRemainingInVendorInNetKg || "N/A"} KG\nRemaining quantity in warehouse: ${quantity?.quantityRemainingInWarehouseInNetKg || "N/A"} KG\nRemaining quantity in production: ${quantity?.quantityRemainingInProductionInNetKg || "N/A"} KG`);
              }

              const remainingPurchaseOrderQty = Number(selectedPo?.remainingQuantity) || 0;
              const remainingSalesOrderQty = Number(selectedSo?.remainingQuantity) || 0;
              const isFromVendor = addViewStates?.shipmentRequestType?.startsWith("FV");
              const isFromWarehouse = addViewStates?.shipmentRequestType?.startsWith("FW");
              const requiresPoLimitCheck = isFromVendor || (isFromWarehouse && (fwCtSelected || fwZfSelected));
              const endsWithTC   = addViewStates?.shipmentRequestType?.endsWith("TC");
              const endsWithTWCT = addViewStates?.shipmentRequestType?.endsWith("TWCT");
              const endsWithTWZF = addViewStates?.shipmentRequestType?.endsWith("TWZF");
              const endsWithTIMP = addViewStates?.shipmentRequestType?.endsWith("TIMP");
              const requiresSoLimitCheck = (endsWithTC || endsWithTWCT || endsWithTWZF || endsWithTIMP) && !!selectedSo;

              if (requiresPoLimitCheck && remainingPurchaseOrderQty - totalPlannedShipmentQty < 0) {
                toast.error(`Shipment not allowed. Remaining PO quantity after shipment would be ${remainingPurchaseOrderQty - totalPlannedShipmentQty}. Reduce shipment quantity.`);
                return;
              }
              if (requiresSoLimitCheck && remainingSalesOrderQty - totalPlannedShipmentQty < 0) {
                toast.error(`Shipment not allowed. Remaining SO quantity after shipment would be ${remainingSalesOrderQty - totalPlannedShipmentQty}. Reduce shipment quantity.`);
                return;
              }
              // Open nicotine/sugar review dialog
              setNicSugarDialogOpen(true);
            }}
            disabled={
              (!fvSelected && !fwSelected) ||
              (!tcSelected && !twSelected && !tpSelected) ||
              (tpSelected && !["FVTIMP", "FVTINW", "FWTIMP", "FWTINW"].includes(addViewStates?.shipmentRequestType)) ||
              (fwSelected && !selectedSi) ||
              (ctSelected && !selectedSo) ||
              (zfSelected && !selectedSo) ||
              (tcSelected && !selectedSo) ||
              (tpSelected && !selectedWarehouse) || (twSelected && !selectedWarehouse) ||
              (tpSelected && ["FVTIMP", "FWTIMP"].includes(addViewStates?.shipmentRequestType) && !selectedSo) ||
              !selectedPo || isSaving
            }
            style={
              (!fvSelected && !fwSelected) || (!tcSelected && !twSelected && !tpSelected)
                ? { whiteSpace: "nowrap" }
                : {}
            }
          >
            {isSaving ? <CircularProgress size={20} /> : "Add"}
          </Button>
        </Stack>

        {/* Nicotine & Sugar confirmation dialog */}
        <NicotineSugarSummary
          open={nicSugarDialogOpen}
          onClose={() => setNicSugarDialogOpen(false)}
          soData={selectedSo}
          poData={selectedPo}
          onConfirm={async () => {
            setNicSugarDialogOpen(false);
            setIsSaving(true);
            try {
              if (splitShipment && splitParts > 1) {
                const newShipmentRequests = [];
                for (let i = 0; i < splitShipmentData.length; i++) {
                  const splitData = splitShipmentData[i];
                  const newShipment = {
                    ...addViewStates,
                    numberOfCases: splitData.numberOfCartons,
                    netWeightPerCase: splitData.netWeightPerCarton,
                    shipmentQuantity: splitData.shipmentQuantity,
                    shipmentQuantityUnit: splitData.shipmentQuantityUnit,
                    cartonsPerContainer: splitData.cartonsPerContainer,
                    shipmentEstimatedTimeOfDeparture: splitData.shipmentETD,
                  };
                  const row = mapShipmentRequest(newShipment);
                  newShipmentRequests.push(row);
                  await createShipmentRequestApi(newShipment);
                }
                setRows([...newShipmentRequests, ...rows]);
              } else {
                const row = mapShipmentRequest(addViewStates);
                setRows([row, ...rows]);
                await createShipmentRequestApi(addViewStates);
              }
              setAddView(false);
              toast.success("Shipment request added successfully.");
              navigate("/shipment-request-view");
            } catch (error) {
              console.error(error?.response?.data || error);
              toast.error("Something went wrong. Please try again.");
            } finally {
              setIsSaving(false);
            }
          }}
        />
      </Stack>
      <br></br>
      {!fvSelected && !fwSelected && (
        <Typography variant="body2" color="error">
          Please select one of 'From Vendor', or 'From Warehouse'.
        </Typography>
      )}
      {!tcSelected && !twSelected && !tpSelected && (
        <Typography variant="body2" color="error">
          Please select one of 'To Customer', 'To Warehouse', or 'To
          Production'.
        </Typography>
      )}
      {!selectedPo && (
        <Typography variant="body2" color="error">
          Please select a PO.
        </Typography>
      )}
       {(fwSelected && !selectedSi) && (
        <Typography variant="body2" color="error">
          Please select a reference SI.
        </Typography>
      )}       
      {((tcSelected && !selectedSo) || (ctSelected && !selectedSo) || (zfSelected && !selectedSo)) && (
        <Typography variant="body2" color="error">
          Please select an SO.
        </Typography>
      )}
      {((tpSelected && !selectedWarehouse) || (twSelected && !selectedWarehouse)) && (
        <Typography variant="body2" color="error">
          Please select a warehouse as destination.
        </Typography>
      )}
      {tpSelected &&
        addViewStates.shipmentRequestType !== "FVTIMP" &&
        addViewStates.shipmentRequestType !== "FVTINW" &&
        addViewStates.shipmentRequestType !== "FWTIMP" &&
        addViewStates.shipmentRequestType !== "FWTINW" && (
          <Typography variant="body2" color="error">
            Please select a production type.
          </Typography>
        )}
    </>
  );
};

export default AddShipmentRequest;
